// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scan-green {
  box-shadow: rgba(54, 241, 8, 0.56) 0px 22px 70px 4px;
}

.scan-red {
  box-shadow: rgba(231, 13, 13, 0.56) 0px 22px 70px 4px;
}

.icon-display-size {
  font-size: 4.5em;
  -webkit-user-select: none;
          user-select: none;
  margin-top: -24px;
}

.tm25 {
  margin-top: 25px;
}

.rtm25 {
  margin-top: -25px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/kiosk-scan-page/kiosk-scan-page.component.scss"],"names":[],"mappings":"AAAA;EACI,oDAAA;AACJ;;AAEA;EACI,qDAAA;AACJ;;AAEA;EACI,gBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,iBAAA;AACJ","sourcesContent":[".scan-green {\r\n    box-shadow: rgba(54, 241, 8, 0.56) 0px 22px 70px 4px;\r\n}\r\n\r\n.scan-red {\r\n    box-shadow: rgba(231, 13, 13, 0.56) 0px 22px 70px 4px;\r\n}\r\n\r\n.icon-display-size {\r\n    font-size: 4.5em;\r\n    user-select: none;\r\n    margin-top: -24px;\r\n}\r\n\r\n.tm25 {\r\n    margin-top: 25px;\r\n}\r\n\r\n.rtm25 {\r\n    margin-top: -25px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
